import { Table, Button } from 'react-bootstrap';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
//import block from '../assets/images/block.png';

function Horario(props) {
	//M=Lunes - T=Martes - W=Miercoles - R=Jueves - F=Viernes - S=Sabado - U=Domingo
	const [dias] = useState(['M', 'T', 'W', 'R', 'F', 'S' , 'U']);
	const [horas] = useState(['06:30-07:30', '07:30-08:30', '08:30-09:30', '09:30-10:30', '10:30-11:30', '11:30-12:30', '12:30-13:30', '13:30-14:30', '14:30-15:30', '15:30-16:30', '16:30-17:30', '17:30-18:30', '18:30-19:30', '19:30-20:30']);
	const descargar = () => {
		window.print();
	}
	const llenartabla = () => {
		//console.log(props.selectcursos);
		//console.log(Object.keys(props.selectcursos));
		return (
			<tbody>
				{horas.map((hora, key1) => {
					var horatemp = hora.replace(/:/g, '').split('-');
					var horainicial = horatemp[0];
					var horafinal = horatemp[1];

					//console.log('HORA INICIAL: '+horainicial+' HORA FINAL: '+horafinal);
					return (
						<tr key={key1}>
							<th className="cell_table text-center" scope="row">
								<p>{hora}</p>
							</th>
							{dias.map((dia, key2) => {
								let nombre_curso = [];
								let nrc = [];
								let profesor = [];
								let fechai = [];
								let fechaf = [];
								let matcur = [];
								let salondia = [];
								let error = "";
								let mystyle = {};

								Object.keys(props.selectcursos).map((key3) => {
									var curso = props.selectcursos[key3];

									let dias = curso.horario['DIAS'].split('/');
									let horas = curso.horario['HORAS'].split('/');
									let salon = curso.horario['SALON'] !== null ? curso.horario['SALON'].split('/') : "X";
									let fechas = curso.horario['FECHAS'].replace(/:/g, '').split('/');

									let indicador0 = dias.findIndex((e) => e === dia);

									if (indicador0 >= 0) {
										dias.map((datadia, indicador) => {
											let horadiacurso = horas[indicador].split('_');
											let horadiacursoinicial = horadiacurso[0];
											let horadiacursofinal = horadiacurso[1];

											if (dia === dias[indicador]) {												
												if (horadiacursoinicial <= horainicial && horadiacursofinal >= horafinal) {													
													let fechahoradiacurso = fechas[indicador].replace(/:/g, '').replace(/-/g, '/').split('_');
													let fechaini = new Date((fechahoradiacurso[0]));
													let fechafin = new Date((fechahoradiacurso[1]));

													matcur.push(key3);
													nombre_curso.push(curso.horario['NOMBRE_ASIGNATURA']);
													nrc.push(curso.horario['NRC']);
													salondia.push(salon[indicador]);
													profesor.push(curso.horario['PROFESOR']);
													fechai.push((fechaini.getDate()).toString().padStart(2, '0') + "/" + (fechaini.getMonth() + 1).toString().padStart(2, '0') + "/" + fechaini.getFullYear());
													fechaf.push((fechafin.getDate()).toString().padStart(2, '0') + "/" + (fechafin.getMonth() + 1).toString().padStart(2, '0') + "/" + fechafin.getFullYear());
												}
											}
										});
									}
									if (nrc.length >= 2) {
										let sw = false;
										mystyle = { border: "1px dotted", padding: "5px", margin: "2px" };
										const search_nrc = nrc.reduce((acc, array_nrc) => {
											const clave = JSON.stringify(array_nrc);
											acc[clave] = ++acc[clave] || 0;
											return acc;
										}, {});
										let duplicados = nrc.filter((nrc) => {
											return search_nrc[JSON.stringify(nrc)];
										});
										//while (sw === false) {
											if (duplicados && duplicados.length > 0) {
												//console.log("1")
												if (nrc.length !== duplicados.length) {
													//console.log("1.1")
													for (let x = 0; x < fechai.length; x++) {
														for (let z = x+1; z < fechai.length; z++) {
															if (fechai[x] === fechai[z] && fechaf[x] === fechaf[z]) {
																console.log("Iguales " + fechai[x] + " = " + fechai[z]);
																mystyle = { border: "1px dotted", padding: "5px", margin: "2px", background:"indianred" };
																sw = true;
															}else{
																if (((fechai[x] >= fechai[z]) && (fechai[x] <= fechaf[z])) && (fechaf[x] >= fechai[z]) && (fechaf[x] <= fechaf[z])) {
																	console.log("aqui " + fechai[x] + " >= " + fechai[z]);
																	mystyle = { border: "1px dotted", padding: "5px", margin: "2px", background:"indianred" };
																	sw = true;
																}
															}
														}
													}
												}else{
													sw= false;
												}
											} else {
												//console.log("2")
												for (let x = 0; x < fechai.length; x++) {
													for (let z = x+1; z < fechai.length; z++) {
														if (fechai[x] === fechai[z] && fechaf[x] === fechaf[z]) {
															//console.log("Iguales " + fechai[x] + " = " + fechai[z]);
															mystyle = { border: "1px dotted", padding: "5px", margin: "2px", background:"indianred" };
															sw = true;
														}else{
															if (((fechai[x] >= fechai[z]) && (fechai[x] <= fechaf[z])) && (fechaf[x] >= fechai[z]) && (fechaf[x] <= fechaf[z])) {
																//console.log("aqui " + fechai[x] + " >= " + fechai[z]);
																mystyle = { border: "1px dotted", padding: "5px", margin: "2px", background:"indianred" };
																sw = true;
															}
														}
													}
												}
											}														
										//}
										if (sw === true) {
											error = "bg-danger";
										}
									}
								})
								return (
									<td className={error + " cell_table"} key={key2}>
										<div className={dia + " " + horainicial + "_" + horafinal + " " + dia + "_" + horainicial + "_" + horafinal}>
											{
												nrc.map((element, index) =>
													<div key={index} style={mystyle}>
														<p><strong><center>{nombre_curso[index]}</center></strong></p>
														<p><strong>Materia curso:</strong> {matcur[index] } </p>
														<p> <strong>  NRC:</strong> {element} </p>
														<p><strong>Profesor:</strong> {profesor[index]}</p>
														<p><strong>Salón:</strong> {salondia[index]} </p>
														<p><strong>Inicio de clases:</strong> {fechai[index]} </p>
														<p><strong>fin de clases:</strong> {fechaf[index]} </p>
													</div>
												)
											}
										</div>
									</td>
								);
							})}
						</tr>
					);
				})}
			</tbody>
		)
	}

	return (
		<div>
			{props.horario &&
				<div>
					<h3 className="titulohorario">{props.horario}</h3>
					<Button id="descargar" className="btn_icon float-right" variant="success" onClick={descargar}>
						<FontAwesomeIcon icon={faFileDownload} />
						Descargar Horario
					</Button>
				</div>
			}

			<Table responsive striped bordered variant="light" id="tablehorario">
				<thead>
					<tr>
						<th scope="col" className=" text-center"></th>
						<th scope="col" className="cell_table text-center">
							<p>Lunes</p>
						</th>
						<th scope="col" className="cell_table text-center">
							<p>Martes</p>
						</th>
						<th scope="col" className="cell_table text-center">
							<p>Miércoles</p>
						</th>
						<th scope="col" className="cell_table text-center">
							<p>Jueves</p>
						</th>
						<th scope="col" className="cell_table text-center">
							<p>Viernes</p>
						</th>
						<th scope="col" className="cell_table text-center">
							<p>Sábado</p>
						</th>
						<th scope="col" className="cell_table text-center">
							<p>Domingo</p>
						</th>
					</tr>
				</thead>

				{llenartabla()}

			</Table>
		</div>
	);
}

export default Horario;

